/**
 * @file 应用案例Store
 * @author FengGuang(fengguang01@baidu.com)
 */

import {useEffect, useState} from 'react';

import {
    fetchGetCase
} from '../../api/pages/caseApi';

import {IPictureCard} from '../../components/picture-card/PictureCard';

// 预请求
let preRequest: any = {
    fetchGetCase: fetchGetCase()
};

const useCaseStore = () => {
    const [caseList, setCaseList] = useState<IPictureCard[]>([]);

    useEffect(() => {
        (async (): Promise<void> => {
            const fetchFunc = preRequest.fetchGetCase || fetchGetCase();
            delete preRequest.fetchGetCase;

            let res;
            try {
                res = await fetchFunc;
            }
            catch (err: any) {
                // ignore
            }
            if (res) {
                const list: any[] = res.body.result.data || [];
                setCaseList(
                    list.map(item => ({
                        title: item.caseName,
                        text: item.caseDescription,
                        img: item.imgUrlPc,
                        link: item.link,
                        target: item.link ? '_blank' : undefined,
                        tagText: item.link ? '查看更多' : '',
                    }))
                );
            }
        })();
    }, []);

    return {caseList};
};

export default useCaseStore;
